// extracted by mini-css-extract-plugin
export default {"loading":"DealerDetails__loading-JPcr","confettiOverlay":"DealerDetails__confettiOverlay-Pz4S"};